// src/App.jsx
//import React from 'react';
import '@cores/security/gisApiKeys';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom'


import AppRoutes from './cores/AppRoutes.jsx';
import { AuthBiogemsProvider } from './cores/security/AuthBiogemsProvider.jsx';

const queryClient = new QueryClient();

/**
 * This hierarchy follows the principle of having more fundamental/global providers 
 * on the outside and more specific/feature-focused providers on the inside.
 * 
 * 1. AuthBiogemsProvider: Global provider for Biogems authentication(supporting login.gov)
 * 2. QueryClientProvider: Global provider for React Query
 * 3. BrowserRouter: Global provider for React Router
 * 4. AppRoutes: Feature-focused provider for routing
 * 
 */
const App = () => {
   return (
    <AuthBiogemsProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </AuthBiogemsProvider>
    
  );
};

export default App;





